import type { FaireProductEntity } from "../../entity_types/product";

export const p_taencmchux: FaireProductEntity = {
  token: "p_taencmchux",
  type: "product",
  name: "Body Wash - Incendier",
  brandToken: "b_phyk4zwbt3",
  brandName: "Mienne",
  imageUrl:
    "https://cdn.faire.com/fastly/b56be97806b1081ba6a3793f77bd96c6d9660fdbe818d6afbfaf937b3519ff97.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7c2e0cb37a327bc91cc80bd792ac2a5c3fd148825e4c2376c172f405c33b4985.jpeg",
    "https://cdn.faire.com/fastly/06ef10512d3be0775d8c85c5f677f4eb98bd467bfe2ab560b0cb1c99e9b01873.jpeg",
    "https://cdn.faire.com/fastly/d4a57bfe4ac3ea740c04c22fc95e4cd08ba31e71784a972a2700b5164957ef2d.jpeg",
    "https://cdn.faire.com/fastly/5e708731c1e41938f95b4efefa43ea4330da706b70bf96324750950c223d5733.jpeg",
    "https://cdn.faire.com/fastly/73a5fe5cadbe5ea407165814232ff1d18bd5894850e2c8e9b2331a17a40eadd9.jpeg",
  ],
  priceDollars: 13.65,
  description:
    "A supercharged body wash that calms, hydrates, and nourishes while gently cleansing skin. The cushiony lather is infused with ultra-calming Hypochlorous Acid, Multi-Weight Hyaluronic Acid, and nourishing Botanical Oils, while mood-shifting adaptogens and two signature scents heighten connection through the senses.\n",
  tags: [],
  msrpDollars: 39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:32:40.902Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
